import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb } from 'semantic-ui-react'

import { scrollToFirstValidateFailElement } from 'core/utilities'
import Information from '../Shareds/Information'
import ConditionOfPayment from '../Shareds/ConditionOfPayment'
import PaymentCondition from '../Shareds/PaymentCondition'
import TimeOfContract from '../Shareds/TimeOfContract'
import TypeOfContract from '../Shareds/TypeOfContract'
import ContactPerson from '../Shareds/Contact'
import Attachment from '../Shareds/Attachment'
import { contractPath } from 'routes'
import {
  validateField,
  validateAttachments,
  validatePaymentConditions
} from '../helper'
import { 
  MainBodyContent, 
  CustomButton,
} from 'components'
import { 
  fetchPOComplete,
  gethPOCompleteDetail,
  gethOptionContract,
  gethOptionTypeOfContract,
  gethOptionAOPT,
  clearContractData,
  createContract,
  getContractWorkflowEditMode
} from 'ducks/contract'
import { 
  showModal,
} from 'ducks/app'
import { 
  fetchRolePurchaseOfficer,
} from 'ducks/options'
import { 
  getHrmsMembers ,
  getAllMembers
} from 'ducks/member'

import { 
  BottomActionsContainer,
  PCondition
} from './styled'
import r from 'reactotron-react-js'

const CreateContract = props => {

  const { 
    history,
    change,
    valueForm,
    poCompleteDetail,
    members,
    poSelected,
    purchaseOfficer,
    isDetail = false,
  } = props

  const [actionName, setActionName] = React.useState('')
  const [alertPCondition, setAlertPCondition] = React.useState(false)

  React.useEffect(()=>{
    props.fetchPOComplete()
    props.gethOptionContract()
    props.gethOptionAOPT()
    props.gethOptionTypeOfContract()
    props.getAllMembers(isDetail)
    // props.getHrmsMembers(isDetail)
    return(()=>{
      props.clearContractData()
    })
  },[])
  
  React.useEffect(()=>{
    if(poSelected&&poSelected.id){
      change('poSelectedNumber',`${poSelected.documentNumber} | ${poSelected.sapNumber} | ${poSelected.title}`)
      change('poId',poSelected.id)
      props.gethPOCompleteDetail(poSelected.id)
    }else{
      change('projectName','')
      change('companyName','')
      change('vendorName','')
      change('totalAmount','')
      change('deductOfRetention','')
      change('prRequester','')
      change('purchasing','')
    }
  },[poSelected])

  React.useEffect(()=>{
    if(valueForm){
      props.getContractWorkflowEditMode({
        creater:props.userName,
        requester:valueForm.requesterUser,
        amount:poCompleteDetail.totalAmount,
        currency:poCompleteDetail.currency,
        companyCode:poCompleteDetail.companyCode
      })
    }
  },[(valueForm&&valueForm.requesterUser),poCompleteDetail])
  
  React.useEffect(()=>{
    if(Object.keys(poCompleteDetail).length){
      change('projectName',poCompleteDetail.projectName)
      change('companyName',`${poCompleteDetail.companyCode} | ${poCompleteDetail.companyName}`)
      change('vendorName',`${poCompleteDetail.vendorCode} | ${poCompleteDetail.vendorName}`)
      change('totalAmount',poCompleteDetail.totalAmount)
      change('deductOfRetention',poCompleteDetail.deductOfRetention)
      change('prRequester',poCompleteDetail.prRequester)
      change('purchasing',poCompleteDetail.purchasing)
      change('purchGroup',poCompleteDetail.purchGroup)
      
      change('poSelectedNumber',`${poSelected.documentNumber} | ${poSelected.sapNumber} | ${poSelected.title}`)
      change('poId',poSelected.id)
    }else{
      change('projectName','')
      change('companyName','')
      change('vendorName','')
      change('totalAmount','')
      change('deductOfRetention','')
      change('prRequester','')
      change('purchasing','')
      change('purchGroup','')


      change('poSelectedNumber','')
      change('poId','')
    }
  },[poCompleteDetail])

  React.useEffect(()=>{
    if(valueForm){
      let member = members.find(m => m.username === valueForm.prRequester)
      if (member) {
        change('prRequesterMobile',member.mobile1)
      } else if(valueForm.prRequesterMobile){
        change('prRequesterMobile','')
      }
    }
  },[valueForm&&valueForm.prRequester])
  
  React.useEffect(()=>{
    if(valueForm&&purchaseOfficer.data.length>0){
      let member = purchaseOfficer.data.find(m => m.username === valueForm.purchasing)
      if (member) {
        change('purchasingMobile',member.mobile1)
      } else if(valueForm.purchasingMobile) {
        change('purchasingMobile','')
      }
    }
  },[valueForm&&valueForm.purchasing])

  React.useEffect(()=>{
    if(valueForm&&valueForm.purchGroup){
      props.fetchRolePurchaseOfficer(valueForm.purchGroup)
    }
  },[valueForm&&valueForm.purchGroup])

 const onSubmitForm = () => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
    .then(() => {
      let errors = validateField(valueForm, actionName)
      if(Object.keys(errors).length){
        scrollToFirstValidateFailElement(errors)
        throw new SubmissionError(errors)
      }else{
        if(actionName=='save'){
          props.createContract(valueForm,history,false)
        }else{
          let missingAttachments = validateAttachments(valueForm)
          if(missingAttachments.length){
            props.showModal(
              true, 
              'Please attach document!',
              <React.Fragment><ul>{missingAttachments.map(v => <li>{v.fieldName}</li>)}</ul></React.Fragment>
            )
          }else{
            let validPaymentCondition = validatePaymentConditions(valueForm)
            if(!validPaymentCondition){
              setAlertPCondition(true)
              props.showModal(
                true, 
                'Systems',
                'Please field Payment Condition!'
              )
            }else{
              let paymentCondition = valueForm.paymentConditions.filter(x=>x.deleted!=true)
              props.createContract({...valueForm,paymentConditions:paymentCondition,forCheck:poCompleteDetail.status!=4},history,true)
            }
          }
        }
      }
    })
  } 

  return (
    <MainBodyContent
      headerTitle='Contract - Create '
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(contractPath)}
            icon="close"
            btnColor="red"
            title="Cancel"
          />
        </div>
      }
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: 'contract',
              content: 'Contract',
              link: true,
              onClick: () => history.push(contractPath),
            },
            { key: 'contractCreate', content: 'Create', active: true },
          ]}
        />
      }
    >
      <Information isCreate/>
      <TypeOfContract isCreate/>
      <ConditionOfPayment isCreate/>
      <PCondition alert={alertPCondition}>
        <PaymentCondition isCreate/>
      </PCondition>
      <TimeOfContract isCreate/>
      <ContactPerson isCreate />
      <Attachment isCreate/>

      <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
        <BottomActionsContainer>
          <Button 
            type='submit'
            content='Save' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>setActionName('save')}
          />
          <Button 
            type='submit'
            content={poCompleteDetail.status==4?'Save & Submit':'Save and Check'} 
            color='blue' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>setActionName('submit')}
          />
        </BottomActionsContainer>
      </form>
    </MainBodyContent>
  )

}

const mapStateToProps = (state, props) => {
  const date = new Date()
  const userName = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  return ({
    initialValues: {
      paymentConditions:[],
      amountOfPaymentType:'PT02',
      contractLanguage:'Thai',
      documentDate:new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      requesterUser: userName.toLowerCase()
    },
    poSelected:state.contract.poSelected.data,
    poCompleteDetail:state.contract.poCompleteDetail.data,
    members: state.member.members,
    userName,
    purchaseOfficer: state.options.purchaseOfficer,
    valueForm: getFormValues('formContract')(state),
  })
}
const mapDispatchToProps = {
  showModal,
  fetchPOComplete,
  gethPOCompleteDetail,
  gethOptionContract,
  gethOptionTypeOfContract,
  clearContractData,
  createContract,
  gethOptionAOPT,
  getHrmsMembers,
  getContractWorkflowEditMode,
  fetchRolePurchaseOfficer,
  getAllMembers
}

const contForm = reduxForm({
  form: 'formContract',
  enableReinitialize: true,
})(CreateContract)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
